/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Placeholder_ResultInputs */

const en_story_bank_placeholder_result = /** @type {(inputs: Story_Bank_Placeholder_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What was the outcome?`)
};

const de_story_bank_placeholder_result = /** @type {(inputs: Story_Bank_Placeholder_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What was the outcome?`)
};

const fr_story_bank_placeholder_result = /** @type {(inputs: Story_Bank_Placeholder_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What was the outcome?`)
};

const es_story_bank_placeholder_result = /** @type {(inputs: Story_Bank_Placeholder_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What was the outcome?`)
};

const it_story_bank_placeholder_result = /** @type {(inputs: Story_Bank_Placeholder_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What was the outcome?`)
};

const nl_story_bank_placeholder_result = /** @type {(inputs: Story_Bank_Placeholder_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What was the outcome?`)
};

const pl_story_bank_placeholder_result = /** @type {(inputs: Story_Bank_Placeholder_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What was the outcome?`)
};

const fi_story_bank_placeholder_result = /** @type {(inputs: Story_Bank_Placeholder_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What was the outcome?`)
};

const da_story_bank_placeholder_result = /** @type {(inputs: Story_Bank_Placeholder_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What was the outcome?`)
};

const sv_story_bank_placeholder_result = /** @type {(inputs: Story_Bank_Placeholder_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What was the outcome?`)
};

/**
* | output |
* | --- |
* | "What was the outcome?" |
*
* @param {Story_Bank_Placeholder_ResultInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_placeholder_result = /** @type {((inputs?: Story_Bank_Placeholder_ResultInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Placeholder_ResultInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_placeholder_result(inputs)
	if (locale === "fr") return fr_story_bank_placeholder_result(inputs)
	if (locale === "es") return es_story_bank_placeholder_result(inputs)
	if (locale === "it") return it_story_bank_placeholder_result(inputs)
	if (locale === "nl") return nl_story_bank_placeholder_result(inputs)
	if (locale === "pl") return pl_story_bank_placeholder_result(inputs)
	if (locale === "fi") return fi_story_bank_placeholder_result(inputs)
	if (locale === "da") return da_story_bank_placeholder_result(inputs)
	if (locale === "sv") return sv_story_bank_placeholder_result(inputs)
	return en_story_bank_placeholder_result(inputs)
});